import React from "react";
import { Link } from "react-router-dom";

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
      <div className="eyebrow text-[color:var(--brand-wood)]">Legal</div>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl leading-[1.05] tracking-tight">{title}</h1>
      <p className="mt-3 text-xs text-[color:var(--brand-woodDark)]">Last updated: {lastUpdated}</p>

      <div className="mt-10 prose-content space-y-6 text-[15px] leading-relaxed text-[color:var(--brand-ink)]">
        {children}
      </div>

      <div className="mt-16 flex flex-wrap gap-4 text-xs">
        <Link data-testid="legal-nav-privacy" to="/privacy" className="rounded-full border border-black/10 px-4 py-2 hover:bg-black/5">Privacy Policy</Link>
        <Link data-testid="legal-nav-terms" to="/terms" className="rounded-full border border-black/10 px-4 py-2 hover:bg-black/5">Terms &amp; Conditions</Link>
        <Link data-testid="legal-nav-refund" to="/refund" className="rounded-full border border-black/10 px-4 py-2 hover:bg-black/5">Refund Policy</Link>
      </div>
    </div>
  );
}

export const Section = ({ title, children, testid }) => (
  <section data-testid={testid}>
    <h2 className="font-display text-2xl sm:text-3xl mt-4 mb-3 tracking-tight">{title}</h2>
    <div className="text-[color:var(--brand-woodDark)] space-y-3">{children}</div>
  </section>
);
